import styled from '@emotion/styled';
import { css } from '@emotion/react';

import breakpoints from 'app/styles/constants/breakpoints';
import { startDirection } from 'app/styles/selectors/markup';
import RGBA from 'app/styles/rgbToRgbaConverter';

const { widthSmall } = breakpoints;

const S = {};

const messageTypes = ({ type }) => {
  const types = {
    error: css`
      background-color: var(--colors-pomegranate);
      color: var(--colors-black);
      fill: var(--colors-black);
    `,
    success: css`
      background-color: var(--colors-granny-smith-apple);
      color: var(--colors-black);
      fill: var(--colors-black);
    `,
    neutral: css`
      background-color: var(--colors-blue-base);
      color: var(--colors-white);
      fill: var(--colors-white);
    `,
  };

  return types[type];
};

S.FlashMessage = styled.div`
  label: FlashMessage;

  display: flex;
  position: fixed;
  top: 0;
  ${startDirection}: 0;
  width: 100%;
  min-height: 2.75rem;
  z-index: var(--z-index-flash-message);
  animation: ${({ animationDirection }) => css`
    message-slide-${animationDirection} 0.2s ease-in-out 0s normal 1 forwards running;
  `};

  ${messageTypes}

  @media (${widthSmall}) {
    min-height: 3rem;
  }

  @keyframes message-slide-down {
    0% {
      transform: translateY(-100%);
    }

    100% {
      transform: translateY(0);
    }
  }

  @keyframes message-slide-up {
    0% {
      transform: translateY(0);
    }

    99% {
      transform: translateY(-100%);
      opacity: 1;
    }

    100% {
      opacity: 0;
    }
  }
`;

S.FlashMessage.Text = styled.div`
  label: Text;

  flex-grow: 1;
  display: flex;
  justify-content: ${startDirection};
  align-items: center;
  padding-${startDirection}: 1.25rem;

  &:hover {
    background-color: ${RGBA('--colors-white', 0.2)};
  }

  @media (${widthSmall}) {
    justify-content: center;
    padding-${startDirection}: 0;
  }
`;

S.FlashMessage.Close = styled.div`
  label: Close;

  display: flex;
  justify-content: center;
  align-items: center;
  height: 100%;
  width: 2.75rem;
  cursor: pointer;
  flex: 0 0 auto;

  &:hover {
    background-color: ${RGBA('--colors-white', 0.2)};
  }

  @media (${widthSmall}) {
    height: 3rem;
    width: 3rem;
  }
`;

S.FlashMessage.Icon = styled.svg`
  label: Icon;

  width: 1.5rem;
  height: 1.5rem;

  background-color: transparent;
  fill: currentColor;
`;

export default S;
